import axios from "axios";

export default {
  name: "userKkl",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getUserKklList(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "user_kkl",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createUserKkl(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "user_kkl",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    editUserKkl(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "put",
          url:
            process.env.VUE_APP_SERVICEURL + "user_kkl",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": 'application/json',
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    nonActiveKkl(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "put",
          url:
            process.env.VUE_APP_SERVICEURL + "user_kkl/deactived",
          data: {
            id_user_kkl: params
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": 'application/json',
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
};
